// Home
export * from "./home.component";




// WEBPACK FOOTER //
// ./src/app/components/home/index.ts